import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "generate-workplan-modal-cdp";

const keys = addTranslations(RESOURCE_NAME, {
    open_button: {
        en: "Export Workplan",
        fr: "Exporter un plan de travail",
    },
    generate_workplan_description: {
        en: "This agent will generate a workplan based on your results of your previous CDP questionnaire",
        fr: "Cet agent générera un plan de travail basé sur vos résultats de votre questionnaire CDP précédent",
    },
    upload_cdp_scorecard: {
        en: "Upload CDP Scorecard",
        fr: "Uploader la scorecard CDP",
    },
    select_thematics: {
        en: "Choose a thematic",
        fr: "Choisir une thématique",
    },
    select_thematics_title: {
        en: "Select Thematics",
        fr: "Sélectionner les thématiques",
    },
    select_thematics_description: {
        en: "Select thematics that are relevant to your organization.",
        fr: "Choisissez les thématiques qui sont pertinentes pour votre organisation.",
    },
    select_tags: {
        en: "Select Tags",
        fr: "Sélectionner les tags",
    },
    generate_workplan: {
        en: "Generate Workplan",
        fr: "Générer un plan de travail",
    },
    generate_workplan_tooltip: {
        en: "Please select a thematic and a tag and upload a scorecard.",
        fr: "Veuillez sélectionner une thématique et un tag et télécharger un scorecard.",
    },
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    select_tags_description: {
        en: "Chose topics that are material to your organization",
        fr: "Choisissez les sujets qui sont pertinents pour votre organisation",
    },
    generate_workplan_success: {
        en: "Workplan generated successfully",
        fr: "Plan de travail généré avec succès",
    },
    generate_workplan_error: {
        en: "Error generating workplan",
        fr: "Erreur lors de la génération du plan de travail",
    },
    question: {
        en: "Question Id",
        fr: "Id de la question",
    },
    score: {
        en: "Importance Score",
        fr: "Score d'importance",
    },
    questionGroupName: {
        en: "Module Name",
        fr: "Nom du module",
    },
    download_workplan_btn: {
        en: "Download Workplan",
        fr: "Télécharger le plan de travail",
    },
});

export function useGenerateCdpWorkplanModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
